// Copy for the unlisted Kestrel anti-cheat landing page (/:lang/kestrel).
// Kept apart from localization.js because it is long-form page content,
// not shared UI strings.
export default {
  en: {
    META_TITLE: "Kestrel — server-side ML anti-cheat by Gunzilla Games",
    META_DESCRIPTION:
      "Kestrel learns the motor signature every player leaves in their inputs and uses it to detect, identify and ban cheaters. No client install.",
    HERO_TAG_PRODUCT: "Product",
    HERO_TAG_CATEGORY: "Anti-cheat",
    HERO_TAG_STATUS: "Beta · live in Off The Grid",
    HERO_CAPTION: "Server-side ML anti-cheat by Gunzilla Games",
    HERO_TITLE_BEFORE: "Detect the ",
    HERO_TITLE_ACCENT: "human",
    HERO_TITLE_AFTER: ", not the hack.",
    HERO_TEXT:
      "Kestrel learns the motor signature every player leaves in their inputs — a pattern no cheat can reproduce — and uses it to detect, identify and ban.",
    HERO_CTA_HOW: "How it works",
    HERO_CTA_VALIDATORS: "Validators Program",
    TRACE_TITLE: "Input trace / 2.4 s window",
    TRACE_LEGEND_HUMAN: "human",
    TRACE_LEGEND_SYNTHETIC: "synthetic",
    TRACE_STAT_CORRECTION: "Micro-correction",
    TRACE_STAT_CORRECTION_VALUE: "Present",
    TRACE_STAT_ENTROPY: "Jitter entropy",
    TRACE_STAT_VERDICT: "Verdict",
    TRACE_STAT_VERDICT_VALUE: "Human",
    SHIFT_LABEL: "The shift",
    SHIFT_TITLE: "Cheat detection has always chased the cheat.",
    SHIFT_TITLE_ACCENT: "Kestrel watches the player.",
    SHIFT_LEGACY_LABEL: "Legacy",
    SHIFT_LEGACY_TEXT:
      "Signature scanning, memory inspection and kernel drivers look for known cheat software on the client. Every new build of a cheat resets the race — and every client component can be studied, patched or disabled.",
    SHIFT_KESTREL_LABEL: "Kestrel",
    SHIFT_KESTREL_TEXT:
      "Models the behaviour behind the inputs. Each person has a unique neuromuscular pattern — reaction latency, micro-corrections, acceleration curves. A cheat can fake an outcome. It cannot fake a body.",
    HOW_LABEL: "How it works",
    HOW_TITLE: "Three properties no client-side anti-cheat can offer.",
    PILLARS: [
      {
        title: "Behavioural detection",
        body: "Kestrel models the neuromuscular pattern in every player's inputs — latency, micro-corrections, acceleration. Aim assistance, triggerbots and macros produce motion no human body generates, and the model sees it regardless of how the cheat is built.",
        note: "Generalises to unseen cheats",
      },
      {
        title: "Server-side only",
        body: "Nothing is installed on the player's machine. No driver, no process, no attack surface. There is no client component to disable, bypass, hook or reverse-engineer.",
        note: "Zero client footprint",
      },
      {
        title: "A black box to attackers",
        body: "Cheaters never see the model, the features it reads or the thresholds it applies. They receive a verdict, not a signal to tune against.",
        note: "No feedback loop for cheat devs",
      },
    ],
    BANS_LABEL: "Enforcement",
    BANS_TITLE_1: "Ban the person.",
    BANS_TITLE_2: "Not the PC.",
    BANS_TEXT:
      "Hardware bans end at the next motherboard or spoofer. Kestrel bans a motor signature. New account, new machine, new network — the same hands produce the same pattern, and the ban follows them for the duration you set.",
    BANS_POINTS: [
      "Device- and account-independent",
      "Time-boxed: days, seasons or permanent",
      "Re-identification on first sessions after return",
    ],
    BANS_PANEL_TITLE: "Signature match / same player, three attempts",
    BANS_MATCH: "Match",
    BANS_ATTEMPTS: [
      { label: "Attempt 1 / original", device: "Desktop · account A" },
      { label: "Attempt 2 / 3 days later", device: "New hardware · account B" },
      { label: "Attempt 3 / 2 weeks later", device: "Laptop · VPN · account C" },
    ],
    VERDICT_BANNED: "Banned",
    VERDICT_MATCHED: "Matched",
    VALIDATORS_LABEL: "GUNZ Validators Program",
    VALIDATORS_TITLE: "Built for Off The Grid.",
    VALIDATORS_TITLE_ACCENT: "Available for our partners.",
    VALIDATORS_TEXT:
      "We're giving back to some of our strongest supporters — holders of Legendary and Ancient GUNZ Validator NFTs. If you hold one of these NFTs, you can get Kestrel completely free.",
    VALIDATORS_CARD_TITLE: "Verify your Validator NFT",
    VALIDATORS_CARD_BADGE: "Limited time",
    VALIDATORS_CARD_TEXT:
      "Contact us to verify your Legendary or Ancient Validator NFT and participate in the program.",
    VALIDATORS_CARD_CTA: "Contact us",
  },
  de: {
    META_TITLE: "Kestrel — serverseitiges ML-Anti-Cheat von Gunzilla Games",
    META_DESCRIPTION:
      "Kestrel lernt die motorische Signatur, die jeder Spieler in seinen Eingaben hinterlässt, und nutzt sie, um Cheater zu erkennen, zu identifizieren und zu sperren. Ohne Client-Installation.",
    HERO_TAG_PRODUCT: "Produkt",
    HERO_TAG_CATEGORY: "Anti-Cheat",
    HERO_TAG_STATUS: "Beta · live in Off The Grid",
    HERO_CAPTION: "Serverseitiges ML-Anti-Cheat von Gunzilla Games",
    HERO_TITLE_BEFORE: "Erkenne den ",
    HERO_TITLE_ACCENT: "Menschen",
    HERO_TITLE_AFTER: ", nicht den Hack.",
    HERO_TEXT:
      "Kestrel lernt die motorische Signatur, die jeder Spieler in seinen Eingaben hinterlässt — ein Muster, das kein Cheat nachbilden kann — und nutzt sie, um zu erkennen, zu identifizieren und zu sperren.",
    HERO_CTA_HOW: "So funktioniert es",
    HERO_CTA_VALIDATORS: "Validators Program",
    TRACE_TITLE: "Eingabeverlauf / 2,4-s-Fenster",
    TRACE_LEGEND_HUMAN: "Mensch",
    TRACE_LEGEND_SYNTHETIC: "synthetisch",
    TRACE_STAT_CORRECTION: "Mikrokorrektur",
    TRACE_STAT_CORRECTION_VALUE: "Vorhanden",
    TRACE_STAT_ENTROPY: "Jitter-Entropie",
    TRACE_STAT_VERDICT: "Urteil",
    TRACE_STAT_VERDICT_VALUE: "Mensch",
    SHIFT_LABEL: "Der Wandel",
    SHIFT_TITLE: "Cheat-Erkennung jagt seit jeher dem Cheat hinterher.",
    SHIFT_TITLE_ACCENT: "Kestrel beobachtet den Spieler.",
    SHIFT_LEGACY_LABEL: "Bisher",
    SHIFT_LEGACY_TEXT:
      "Signaturscans, Speicherprüfung und Kernel-Treiber suchen auf dem Client nach bekannter Cheat-Software. Jeder neue Build eines Cheats startet das Rennen von vorn — und jede Client-Komponente kann analysiert, gepatcht oder deaktiviert werden.",
    SHIFT_KESTREL_LABEL: "Kestrel",
    SHIFT_KESTREL_TEXT:
      "Modelliert das Verhalten hinter den Eingaben. Jeder Mensch hat ein einzigartiges neuromuskuläres Muster — Reaktionszeit, Mikrokorrekturen, Beschleunigungskurven. Ein Cheat kann ein Ergebnis fälschen. Einen Körper kann er nicht fälschen.",
    HOW_LABEL: "So funktioniert es",
    HOW_TITLE: "Drei Eigenschaften, die kein clientseitiges Anti-Cheat bieten kann.",
    PILLARS: [
      {
        title: "Verhaltensbasierte Erkennung",
        body: "Kestrel modelliert das neuromuskuläre Muster in den Eingaben jedes Spielers — Latenz, Mikrokorrekturen, Beschleunigung. Zielhilfen, Triggerbots und Makros erzeugen Bewegungen, die kein menschlicher Körper hervorbringt, und das Modell erkennt sie unabhängig davon, wie der Cheat gebaut ist.",
        note: "Erkennt auch unbekannte Cheats",
      },
      {
        title: "Ausschließlich serverseitig",
        body: "Auf dem Rechner des Spielers wird nichts installiert. Kein Treiber, kein Prozess, keine Angriffsfläche. Es gibt keine Client-Komponente, die sich deaktivieren, umgehen, hooken oder per Reverse Engineering analysieren ließe.",
        note: "Null Client-Footprint",
      },
      {
        title: "Eine Blackbox für Angreifer",
        body: "Cheater sehen weder das Modell noch die Merkmale, die es auswertet, noch die Schwellenwerte, die es anwendet. Sie erhalten ein Urteil, kein Signal, auf das sie sich einstellen können.",
        note: "Keine Feedbackschleife für Cheat-Entwickler",
      },
    ],
    BANS_LABEL: "Durchsetzung",
    BANS_TITLE_1: "Sperre die Person.",
    BANS_TITLE_2: "Nicht den PC.",
    BANS_TEXT:
      "Hardware-Sperren enden beim nächsten Mainboard oder Spoofer. Kestrel sperrt eine motorische Signatur. Neuer Account, neuer Rechner, neues Netzwerk — dieselben Hände erzeugen dasselbe Muster, und die Sperre folgt ihnen für die von dir festgelegte Dauer.",
    BANS_POINTS: [
      "Unabhängig von Gerät und Account",
      "Befristet: Tage, Seasons oder dauerhaft",
      "Wiedererkennung in den ersten Sessions nach der Rückkehr",
    ],
    BANS_PANEL_TITLE: "Signaturabgleich / derselbe Spieler, drei Versuche",
    BANS_MATCH: "Übereinstimmung",
    BANS_ATTEMPTS: [
      { label: "Versuch 1 / Original", device: "Desktop · Account A" },
      { label: "Versuch 2 / 3 Tage später", device: "Neue Hardware · Account B" },
      { label: "Versuch 3 / 2 Wochen später", device: "Laptop · VPN · Account C" },
    ],
    VERDICT_BANNED: "Gesperrt",
    VERDICT_MATCHED: "Erkannt",
    VALIDATORS_LABEL: "GUNZ Validators Program",
    VALIDATORS_TITLE: "Entwickelt für Off The Grid.",
    VALIDATORS_TITLE_ACCENT: "Verfügbar für unsere Partner.",
    VALIDATORS_TEXT:
      "Für begrenzte Zeit geben wir einigen unserer stärksten Unterstützer etwas zurück — Inhabern von Legendary und Ancient GUNZ Validator NFTs. Wenn du eines dieser NFTs besitzt, erhältst du Kestrel komplett kostenlos.",
    VALIDATORS_CARD_TITLE: "Validator-NFT verifizieren",
    VALIDATORS_CARD_BADGE: "Begrenzte Zeit",
    VALIDATORS_CARD_TEXT:
      "Kontaktiere uns, um dein Legendary oder Ancient Validator NFT zu verifizieren und am Programm teilzunehmen.",
    VALIDATORS_CARD_CTA: "Kontakt",
  },
  ua: {
    META_TITLE: "Kestrel — серверний ML-античит від Gunzilla Games",
    META_DESCRIPTION:
      "Kestrel вивчає моторний підпис, який кожен гравець залишає у своєму введенні, і використовує його, щоб виявляти, ідентифікувати та банити читерів. Без встановлення на клієнт.",
    HERO_TAG_PRODUCT: "Продукт",
    HERO_TAG_CATEGORY: "Античит",
    HERO_TAG_STATUS: "Бета · працює в Off The Grid",
    HERO_CAPTION: "Серверний ML-античит від Gunzilla Games",
    HERO_TITLE_BEFORE: "Розпізнай ",
    HERO_TITLE_ACCENT: "людину",
    HERO_TITLE_AFTER: ", а не чит.",
    HERO_TEXT:
      "Kestrel вивчає моторний підпис, який кожен гравець залишає у своєму введенні, — патерн, який жоден чит не здатен відтворити, — і використовує його, щоб виявляти, ідентифікувати та банити.",
    HERO_CTA_HOW: "Як це працює",
    HERO_CTA_VALIDATORS: "Validators Program",
    TRACE_TITLE: "Графік введення / вікно 2,4 с",
    TRACE_LEGEND_HUMAN: "людина",
    TRACE_LEGEND_SYNTHETIC: "синтетика",
    TRACE_STAT_CORRECTION: "Мікрокорекція",
    TRACE_STAT_CORRECTION_VALUE: "Є",
    TRACE_STAT_ENTROPY: "Ентропія джитеру",
    TRACE_STAT_VERDICT: "Вердикт",
    TRACE_STAT_VERDICT_VALUE: "Людина",
    SHIFT_LABEL: "Зміна підходу",
    SHIFT_TITLE: "Античити завжди ганялися за читом.",
    SHIFT_TITLE_ACCENT: "Kestrel стежить за гравцем.",
    SHIFT_LEGACY_LABEL: "Як було",
    SHIFT_LEGACY_TEXT:
      "Сканування сигнатур, перевірка пам'яті та драйвери ядра шукають на клієнті відоме читерське ПЗ. Кожна нова збірка чита запускає перегони наново — а кожен клієнтський компонент можна дослідити, пропатчити чи вимкнути.",
    SHIFT_KESTREL_LABEL: "Kestrel",
    SHIFT_KESTREL_TEXT:
      "Моделює поведінку, що стоїть за введенням. Кожна людина має унікальний нервово-м'язовий патерн — затримку реакції, мікрокорекції, криві прискорення. Чит може підробити результат. Тіло він не підробить.",
    HOW_LABEL: "Як це працює",
    HOW_TITLE: "Три властивості, яких не дасть жоден клієнтський античит.",
    PILLARS: [
      {
        title: "Поведінкове виявлення",
        body: "Kestrel моделює нервово-м'язовий патерн у введенні кожного гравця — затримку, мікрокорекції, прискорення. Аймботи, тригерботи та макроси створюють рухи, яких не здатне відтворити людське тіло, і модель бачить їх незалежно від того, як влаштований чит.",
        note: "Ловить навіть невідомі чити",
      },
      {
        title: "Лише на сервері",
        body: "На комп'ютер гравця нічого не встановлюється. Ні драйвера, ні процесу, ні поверхні для атаки. Немає клієнтського компонента, який можна вимкнути, обійти, перехопити чи розреверсити.",
        note: "Нуль слідів на клієнті",
      },
      {
        title: "Чорна скринька для атакувальників",
        body: "Читери ніколи не бачать ні модель, ні ознаки, які вона аналізує, ні пороги, які застосовує. Вони отримують вердикт, а не сигнал, під який можна підлаштуватися.",
        note: "Жодного зворотного зв'язку для розробників читів",
      },
    ],
    BANS_LABEL: "Покарання",
    BANS_TITLE_1: "Бань людину.",
    BANS_TITLE_2: "Не ПК.",
    BANS_TEXT:
      "Бан за залізом закінчується з новою материнською платою чи спуфером. Kestrel банить моторний підпис. Новий акаунт, новий комп'ютер, нова мережа — ті самі руки створюють той самий патерн, і бан переслідує їх стільки, скільки ви встановили.",
    BANS_POINTS: [
      "Не залежить від пристрою та акаунта",
      "Обмежений у часі: дні, сезони або назавжди",
      "Повторна ідентифікація з перших сесій після повернення",
    ],
    BANS_PANEL_TITLE: "Збіг підпису / той самий гравець, три спроби",
    BANS_MATCH: "Збіг",
    BANS_ATTEMPTS: [
      { label: "Спроба 1 / оригінал", device: "Десктоп · акаунт A" },
      { label: "Спроба 2 / через 3 дні", device: "Нове залізо · акаунт B" },
      { label: "Спроба 3 / через 2 тижні", device: "Ноутбук · VPN · акаунт C" },
    ],
    VERDICT_BANNED: "Бан",
    VERDICT_MATCHED: "Впізнано",
    VALIDATORS_LABEL: "GUNZ Validators Program",
    VALIDATORS_TITLE: "Створено для Off The Grid.",
    VALIDATORS_TITLE_ACCENT: "Доступно для наших партнерів.",
    VALIDATORS_TEXT:
      "Протягом обмеженого часу ми віддячуємо нашим найвідданішим прихильникам — власникам Legendary та Ancient GUNZ Validator NFT. Якщо у вас є один із цих NFT, ви можете отримати Kestrel абсолютно безкоштовно.",
    VALIDATORS_CARD_TITLE: "Підтвердіть свій Validator NFT",
    VALIDATORS_CARD_BADGE: "Обмежений час",
    VALIDATORS_CARD_TEXT:
      "Зв'яжіться з нами, щоб підтвердити свій Legendary або Ancient Validator NFT і взяти участь у програмі.",
    VALIDATORS_CARD_CTA: "Зв'язатися",
  },
};
